import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  standalone: true,
  selector: 'app-jkloading',
  templateUrl: './jkloading.component.html',
  styleUrl: './jkloading.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [  MatProgressSpinnerModule]
})
export class JkloadingComponent {
  public readonly isLoading = input<boolean>(true);
  public readonly message = input<string>('Loading...');
  public readonly type = input<number>(1); // 1: spinner, 2: progress bar

}
